import { render, staticRenderFns } from "./SpecialPrice.vue?vue&type=template&id=5042e773"
import script from "./SpecialPrice.vue?vue&type=script&lang=js"
export * from "./SpecialPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports